import VuexPersistence from 'vuex-persist';
import storage from '../storage';

export const persistence = new VuexPersistence({
  storage,
  modules: ['cookie'],
  key: '_s',
});

export const sessionPersistence = new VuexPersistence({
  storage,
  reducer(state) {
    const { productToBuy } = state.purchase;

    return {
      session: state.session,
      purchase: {
        productToBuy,
      },
    };
  },
});
